import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=c6373afc&scoped=true&"
import script from "./blank.vue?vue&type=script&lang=js&"
export * from "./blank.vue?vue&type=script&lang=js&"
import style0 from "./blank.vue?vue&type=style&index=0&id=c6373afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6373afc",
  null
  
)

export default component.exports